<template>
  <div class="page">
    <com-banner></com-banner>
    <div class="header">
      <div class="header-avatar"><img :src="info.avatar" /></div>
      <div class="header-d">
        <div class="header-account">{{ info.acc }}</div>
        <div class="header-tip1"></div>
        <!-- <div class="header-p">我的球鞋马上就可以发货啦，快帮我加速一下~</div> -->
      </div>
    </div>
    <div class="shoe">
      <div class="shoe-d">
        <div class="page1-shoe">
          <img :src="shoe.img" />
          <div class="shoe-logo"><img :src="shoe.logo" /></div>
          <div class="page1-shoe-d">
            <div class="shoe-price">¥{{ shoe.price }}</div>
            <div class="shoe-name">{{ shoe.name }}</div>
            <div class="shoe-c"></div>
            <!-- <div class="shoe-tips">全部球鞋由品牌方认证、直供</div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="progress">
        <div class="progress-tips" v-if="progress<0||progress>=100">即将发货</div>
        <div class="progress-tips" v-else>仅差<span>{{ remainProgress }}%</span>立即发货</div>
        <div class="progress-bar"><div class="progress-bar-d" :style="{width: `${progress}%`}"></div></div>
      </div>
      <div class="btn btn1" @click="handleGo"></div>
    </div>
    <com-footer></com-footer>
  </div>
</template>

<script>
import comBanner from '@/components/banner'
import comFooter from '@/components/footer'
import { getShoe } from '@/utils/index'

export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    shoe() {
      return getShoe(this.info.shoeid)
    },
    progress() {
      let progress = parseInt(this.info.progress)
      isNaN(progress) && (progress = 10000)
      progress = progress / 100
      return progress
    },
    remainProgress() {
      const progress = this.progress
      if (progress === parseInt(progress)) {
        return 100 - progress
      } else {
        return (100 - progress).toFixed(2)
      }
    }
  },
  methods: {
    handleGo() {
      this.$emit('go')
    }
  },
  components: {
    comBanner,
    comFooter
  }
}
</script>

<style lang="less" scoped>
@import '../assets/less/mixin.less';

.page1-shoe {
  position: relative;
  text-align: center;
  img {
    display: block;
    margin: 0 auto;
    height: 5.4rem;
  }
  .shoe-logo {
    position: absolute;
    right: .3rem;
    top: 0;
    width: 1rem;
    height: 1rem;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .page1-shoe-d {
    margin-left: .77rem;
    margin-right: .5rem;
    text-align: left;
  }
  .shoe-price {
    font-size: .7rem;
    color: #ff0060;
    .ellipsis();
  }
  .shoe-name {
    line-height: .55rem;
    font-size: .42rem;
    color: #fff;
    .ellipsis();
  }
  .shoe-c {
    width: 3.35rem;
    height: .25rem;
    .bg('../img/c1.png');
  }
  .shoe-tips {
    padding-left: .28rem;
    line-height: .3rem;
    font-size: .24rem;
    color: rgba(255, 255, 255, .5);
    .ellipsis();
    .bg('../img/icon_v.png', .2rem .23rem);
    background-position: left center;
  }
}
@media screen and (min-height: 571px) and (max-height: 690px) {
  .page1-shoe {
    img{
      height: 4rem;
    }
    .shoe-price {
      // font-size: .48rem;
    }
    .shoe-name {
      line-height: .5rem;
      // font-size: .32rem;
    }
  }
}
@media screen and (min-height: 521px) and (max-height: 570px) {
  .page1-shoe {
    img{
      height: 3.4rem;
    }
    .shoe-price {
      // font-size: .4rem;
    }
    .shoe-name {
      line-height: .42rem;
      // font-size: .28rem;
    }
  }
}
@media screen and (min-height: 461px) and (max-height: 520px) {
  .page1-shoe {
    img{
      height: 3rem;
    }
    .shoe-price {
      // font-size: .4rem;
    }
    .shoe-name {
      line-height: .42rem;
      // font-size: .28rem;
    }
  }
}
@media screen and (max-height: 460px) {
  .page1-shoe {
    img{
      height: 2.6rem;
    }
    .shoe-price {
      // font-size: .4rem;
    }
    .shoe-name {
      line-height: .42rem;
      // font-size: .28rem;
    }
  }
}
</style>
